import React from 'react';
import './InsuranceSummaryHomepage.css';
import goldMedal from './InsuranceSummaryHomepageGoldMedal.png';
const InsuranceSummaryHomepage = () => {
  return (
    <div className="InsuranceSummaryHomepage-container">
      <div className="InsuranceSummaryHomepage-content">
        <div className="InsuranceSummaryHomepage-text">
            <h1 className="InsuranceSummaryHomepage-title">
           רוכשים מונית? אל תשכחו ביטוח
          </h1>
          <div className="InsuranceSummaryHomepage-medalWrapper">
  <img src={goldMedal} alt="המלצת האתר" className="InsuranceSummaryHomepage-medalImage" />
  <span className="InsuranceSummaryHomepage-medalText">המלצת האתר</span>
</div>
          <h2 className="InsuranceSummaryHomepage-title2">
            משה ציון – סוכן הביטוח האישי שלך למונית
          </h2>
          <p className="InsuranceSummaryHomepage-paragraph">
            באתר <strong>קנה טקסי</strong> אנחנו מבינים כמה חשוב לך לנהוג בראש שקט.
            לכן אנחנו ממליצים בחום על <strong>משה ציון</strong> – סוכן ביטוח בעל ניסיון רב בתחום המוניות,
            שמלווה נהגים בכל שלבי הביטוח, עם יחס אישי, מקצועיות וזמינות מלאה.
          </p>
          <p className="InsuranceSummaryHomepage-paragraph">
            ביטוח למונית זה לא רק חובה חוקית – זו גם ההגנה שלך, של הנוסעים שלך, ושל ההכנסה שלך.
            עם משה, תקבל פוליסה מותאמת אישית: <strong>ביטוח חובה</strong>, <strong>ביטוח צד ג'</strong> ו־<strong>ביטוח מקיף</strong> – במחיר משתלם ועם כיסויים אמיתיים.
          </p>
          <p className="InsuranceSummaryHomepage-paragraph">
            אל תתפשר על ביטוח למונית. בחר בסוכן אמיתי שמבין אותך.
            צור קשר עוד היום וקבל הצעת מחיר משתלמת במיוחד.
          </p>
          <p className="InsuranceSummaryHomepage-seoText">
            ביטוח מונית חובה | ביטוח צד ג' למוניות | ביטוח מקיף רכב הסעות | הצעת מחיר לביטוח מונית | סוכן מומלץ נהגי מוניות | קנה טקסי ביטוחי רכב מסחרי
          </p>
          <div className="InsuranceSummaryHomepage-buttonWrapper">
            <button className="hero-button" onClick={() => window.location.href = '/InsuranceTaxi'}>
              לפרטים על ביטוחי מוניות 
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InsuranceSummaryHomepage;
